import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ContextDynamicProvider } from "./Components/Context/ContextDynamic";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ContextDynamicProvider>
        <App />
      </ContextDynamicProvider>
    </BrowserRouter>
  </React.StrictMode>
);
